import { render, staticRenderFns } from "./Template22.vue?vue&type=template&id=53787ebf&scoped=true&"
import script from "./Template22.vue?vue&type=script&lang=js&"
export * from "./Template22.vue?vue&type=script&lang=js&"
import style0 from "./Template22.vue?vue&type=style&index=0&id=53787ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53787ebf",
  null
  
)

export default component.exports